import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';

import Camera from '../../components/gui/camera';

@observer
class ProductBarcodeScanner extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sessionid: new Date().getTime(),
        };
        this.mainContainer = null;
    }

    cameraCallback = async (data) => {
        const { callback = () => {} } = this.props;
        console.log(data);
        callback(data);
    }

    render() {
        const {
        } = this.props;
        const { appState, userStore, productStore } = this.props.stores;
        const { user = {}, isAdmin, isTester, isVeterinary } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100 h-100' style='padding-top: 0px; padding-bottom: 100px;'>
                    <div class='mt-1 mb-1 text-bg-primary rounded-lg mx-1 text-center'>
                        <Text id='products.barcodeScanner-title'>Products Barcode Scanner</Text>
                    </div>
                    <Camera
                        fps={2}
                        stores={this.props.stores}
                        showCapture={false}
                        showCameraToggle={true}
                        scanQRCodes={false}
                        scanBarcodes={true}
                        callback={this.cameraCallback}
                        useHighResolution={false}
                    />
                </div>
            </div>
        </>);
    }
}

export default ProductBarcodeScanner;
